import { Link } from 'react-router-dom';
import { useSession } from '../context/session-context';
import { Button } from '../components/ui/button';

const HomePage = () => {
  const { session } = useSession();

  return (
    <div className="flex flex-col items-center justify-between min-h-screen p-4 text-center bg-bg-main">
      <div className="flex-1 flex flex-col items-center justify-center gap-8 pt-12">
        <div className="w-20 h-20">
          <img
            src="/images/llaami.svg"
            alt="Llaami Logo"
            className="w-full h-full"
          />
        </div>

        <div>
          <h1 className="text-3xl font-bold mb-3 text-title">Llaami</h1>
          <p className="text-subheading">
            Learn at your own pace, track your progress
          </p>
        </div>
      </div>

      <div className="w-full space-y-4 mb-8 max-w-sm mx-auto">
        {session ? (
          <Link to="/courses" className="block w-full">
            <Button
              size="lg"
              className="w-full bg-accent-purple text-white hover:bg-accent-purple/90 rounded-full py-6"
            >
              Go to courses
            </Button>
          </Link>
        ) : (
          <Link to="/sign-in" className="block w-full">
            <Button
              size="lg"
              className="w-full bg-accent-purple text-title hover:bg-accent-purple/90 rounded-full py-6"
            >
              Get Started
            </Button>
          </Link>
        )}
      </div>
    </div>
  );
};

export default HomePage;
